/*! aem-component-data-util 1.1.0 */
import{useSSRContext as n}from"vue";function o(o){if(!("undefined"!=typeof window)){const o=n()?.AEMContext;return{payload:o?.payload,config:o?.config}}const r=(window.top||window).aemNamespace.componentData;return o?Array.isArray(o)?Object.fromEntries(o.map((n=>[n,r[n]]))):r[o]:r}export{o as getComponentData};
//# sourceMappingURL=index.js.map
